var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const MARKDOWN_COMPONENTS = {
    h1: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<h1 {...nodeProps} className="text-2xl font-bold">
			{nodeProps.children}
		</h1>);
    },
    h2: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<h2 {...nodeProps} className="text-xl font-bold">
			{nodeProps.children}
		</h2>);
    },
    h3: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<h3 {...nodeProps} className="text-lg font-bold">
			{nodeProps.children}
		</h3>);
    },
    h4: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<h4 {...nodeProps} className="text-base font-bold">
			{nodeProps.children}
		</h4>);
    },
    h5: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<h5 {...nodeProps} className="text-sm font-bold">
			{nodeProps.children}
		</h5>);
    },
    hr: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<hr {...nodeProps} className="border-t border-dark-1 my-4"/>);
    },
    a: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<a {...nodeProps} className="text-link underline" href={nodeProps.href} target="_blank" rel="noopener noreferrer">
			{nodeProps.children}
		</a>);
    },
    ol: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<ol {...nodeProps} className="list-decimal my-1 list-inside">
			{nodeProps.children}
		</ol>);
    },
    ul: (_a) => {
        var { node } = _a, nodeProps = __rest(_a, ["node"]);
        return (<ul {...nodeProps} className="list-disc my-1 list-inside">
			{nodeProps.children}
		</ul>);
    },
};
